import React from "react";
import PropTypes from "prop-types";
import { UITabs } from "../../../../components/ui";

const ApplicantReportTabs = ({
  timeSheet,
  activeTab,
  onTabChange,
  shiftsContent,
  trainingsContent,
}) => {
  const tabs = [
    {
      value: "shifts",
      label: timeSheet.applicantReport.shiftsTab,
    },
    {
      value: "trainings",
      label: timeSheet.applicantReport.trainingsTab,
    },
  ];

  return (
    <UITabs
      tabs={tabs}
      value={activeTab}
      onChange={onTabChange}
      variant="scrollable"
      scrollButtons={false}
      classNames={{ root: "applicant-report-page__tabs" }}
      rootSx={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-24)",
      }}
    >
      {activeTab === "shifts" && shiftsContent}
      {activeTab === "trainings" && trainingsContent}
    </UITabs>
  );
};

ApplicantReportTabs.propTypes = {
  timeSheet: PropTypes.object.isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  shiftsContent: PropTypes.node.isRequired,
  trainingsContent: PropTypes.node.isRequired,
};

export default ApplicantReportTabs;
